import { FC } from "react";

interface GlobeIconSVGProps {
    className?: string;
}

const GlobeIconSVG: FC<GlobeIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="33"
            height="32"
            viewBox="0 0 33 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.8337 16.0013C29.8337 23.3651 23.8641 29.3346 16.5003 29.3346M29.8337 16.0013C29.8337 8.6375 23.8641 2.66797 16.5003 2.66797M29.8337 16.0013H3.16699M16.5003 29.3346C9.13653 29.3346 3.16699 23.3651 3.16699 16.0013M16.5003 29.3346C13.0766 25.7398 11.167 20.9656 11.167 16.0013C11.167 11.037 13.0766 6.26284 16.5003 2.66797M16.5003 29.3346C19.924 25.7398 21.8337 20.9656 21.8337 16.0013C21.8337 11.037 19.924 6.26284 16.5003 2.66797M3.16699 16.0013C3.16699 8.6375 9.13653 2.66797 16.5003 2.66797"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default GlobeIconSVG;
